// English translation

const en = {
  "hotel.folio.no_guest": "No Guest",
  "hotel.folio.registration_card.report": "Registration Card",
};

export default en;
